import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { CheckCircle, Clock, UserPlus, Mail, Receipt, Calendar, User, Tag , LogIn } from 'lucide-react';
import { useUsers } from '../../../metodos/userContext';
import { useWompiModel } from '../../../modelos/WompiPagos/modeloWompiPagos';
import LoadingWidget from '../../../components/Loadings/LoadingWidget';
import ErrorWidget from '../../../components/Loadings/ErrorWidget';
import { useDetalleSolicitudModel } from '../../../modelos/Solicitudes/modeloSolicitud';
import { formatearFechaAntesDe, formatearPrecio } from '../../../utils/utils';
import { useContabilidadModel } from '../../../modelos/Contabilidad/modeloContabilidad';
import { BotonAtras, BotonVolver } from '../../../utils/navigator';

const PagoResultado = () => {
    const { idTransaccion , pago } = useParams();
    const { usuario } = useUsers();
    const navigate = useNavigate();
    const location = useLocation();

    const {
        obtenerTrasaccion,
        infoPago,
        loadingtransaccion,
        errortransaccion,
    } = useWompiModel();
    const {
        solicitud,
        loadingSolicitudes,
        errorSolicitudes,
        cargarSolicitudPorId
    } = useDetalleSolicitudModel();
    const {
        servicio,
        loadingServicios,
        errorServicios,
        cargarServicioPorIdSolicitud,
        cargarServicioPorCodigo,
    } = useContabilidadModel();

    //cargar la trasnaccion
    useEffect(() => {
        obtenerTrasaccion(idTransaccion);
    }, [idTransaccion]);

    useEffect(() => {
        if (infoPago?.reference) {
            const partes = infoPago.reference.split('_');
            const tipoEntidad = partes[0];
            const idEntidad = partes[1];

            if (tipoEntidad === "SOLICITUD") {
                // Si la transacción dice solicitud, cargamos la solicitud primero
                cargarSolicitudPorId(idEntidad, "DUFY ASESORIAS",pago);
            } else if (tipoEntidad === "SERVICIO") {
                // Si dice servicio, cargamos el servicio primero
                cargarServicioPorCodigo( "DUFY ASESORIAS" , idEntidad);
                console.log("carngaod servicio por codigo",tipoEntidad,idEntidad);
            }
        }
    }, [infoPago]);

    // 3. Cargar EL SERVICIO
    useEffect(() => {
        // Si cargamos una solicitud, intentamos buscar su servicio asociado
        if (solicitud?.idcotizacion) {
            cargarServicioPorIdSolicitud("DUFY ASESORIAS", solicitud.idcotizacion);
        }
    }, [solicitud?.idcotizacion]);

    //CARGAR LA SOLICITUD
    useEffect(() => {
        if (servicio?.idsolicitud) {
            cargarSolicitudPorId(servicio.idsolicitud, "DUFY ASESORIAS");
        }
    }, [servicio?.idsolicitud]);

    if (loadingtransaccion || loadingServicios || loadingSolicitudes){
         return <LoadingWidget
            mensaje={"Procesando pago..."}
        />;
    } 
       
    if (errortransaccion && errorSolicitudes && errorServicios){
         return <ErrorWidget
            mensaje={"Hubo un error al cargar la informacion"}
        />;
    }

    const getReferenciaData = () => {
        if (!infoPago?.reference) return { tipo: null, id: null };
        const partes = infoPago.reference.split('_');
        return { tipo: partes[0], id: partes[1] };
    };
    const { tipo: tipoEntidad, id: idEntidad } = getReferenciaData();

    const status = infoPago?.status;
    const esExitoso = status === 'APPROVED';
    const esPendiente = status === 'PENDING';
    const esRechazado = status === 'DECLINED' || status === 'VOIDED' || status === 'ERROR';

    const obtenerMensajeEstado = () => {
        if (esPendiente) return "Estamos esperando la confirmación de tu entidad financiera. Esto puede tardar unos minutos.";
        if (esRechazado) return "La transacción no pudo ser procesada por el medio de pago. No se ha realizado ningún cobro.";
        return "";
    };

    //TRANSACCION EXITOSA
    const SolicitudAgendadaWidget = () => {
        return (
            <div className="p-2 md:p-6 w-full">
                <div className="border-2 border-dashed border-indigo-100 rounded-3xl p-6 bg-slate-50/50 relative">
                    <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-white px-4 py-1 rounded-full border border-gray-100 text-[10px] font-black text-indigo-500 uppercase tracking-[0.2em] shadow-sm">
                        Confirmación de Servicio
                    </div>
                    
                    <div className="space-y-6">
                        <h2 className="text-center text-xl font-black text-slate-800 tracking-tight leading-tight pt-2">
                            TALLERES DUFY ASESORÍAS
                        </h2>
                        
                        <div className="grid grid-cols-1 gap-4 bg-white p-4 rounded-2xl shadow-sm border border-slate-100">
                            <div className="flex items-center gap-4">
                                <div className="p-2 bg-indigo-50 rounded-lg text-indigo-600"><Tag size={20} /></div>
                                <div>
                                    <p className="text-[10px] uppercase font-bold text-slate-400">Materia</p>
                                    <p className="font-bold text-slate-700 text-lg leading-none">{solicitud?.materia}</p>
                                </div>
                            </div>
                            <div className="flex items-center gap-4">
                                <div className="p-2 bg-emerald-50 rounded-lg text-emerald-600"><Receipt size={20} /></div>
                                <div>
                                    <p className="text-[10px] uppercase font-bold text-slate-400">Precio</p>
                                    <p className="font-bold text-slate-700 text-lg leading-none">$ {formatearPrecio(solicitud?.precioCobradoCliente)}</p>
                                </div>
                            </div>
                            <div className="flex items-center gap-4">
                                <div className="p-2 bg-blue-50 rounded-lg text-blue-600"><Calendar size={20} /></div>
                                <div>
                                    <p className="text-[10px] uppercase font-bold text-slate-400">Fecha de entrega</p>
                                    <p className="font-bold text-slate-700 text-lg leading-none">{formatearFechaAntesDe(solicitud?.fechaentrega)}</p>
                                </div>
                            </div>
                        </div>

                        <div className="mt-4">
                            <div className={`p-5 rounded-2xl text-center border-2 transition-all ${
                                solicitud?.Estado === 'AGENDADO' 
                                ? "bg-emerald-50 border-emerald-200" 
                                : "bg-indigo-600 border-indigo-600 shadow-lg shadow-indigo-100"
                            }`}>
                                <p className={`text-[10px] uppercase font-black tracking-widest mb-1 ${
                                    solicitud?.Estado === 'AGENDADO' ? "text-emerald-600" : "text-indigo-100"
                                }`}>
                                    Código de confirmación
                                </p>
                                <p className={`text-3xl font-mono font-black ${
                                    solicitud?.Estado === 'AGENDADO' ? "text-emerald-700" : "text-white animate-pulse"
                                }`}>
                                    {solicitud?.Estado === 'AGENDADO' ? `${servicio?.codigo}` : "GENERANDO..."}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                {solicitud?.Estado !== "AGENDADO" && (
                    <div className="mt-6">
                        <div className="bg-blue-600 rounded-2xl p-4 flex items-start gap-3 shadow-md shadow-blue-100">
                            <span className="text-2xl">🚀</span>
                            <p className="text-white text-sm font-medium leading-snug">
                                <strong>¡Casi listo!</strong> En unos minutos agendaremos tu servicio y enviaremos los detalles a tu email.
                            </p>
                        </div>
                    </div>
                )}
            </div>
        );
    }

    const ServicioAgendadoWidget = () =>{
        const saldoPendiente = servicio?.getSaldoPendienteCliente();
        const estaTotalmentePago = saldoPendiente <= 0;

        return(
            <div className="space-y-4">
                <h2 className="text-center font-bold text-gray-800 border-b pb-2">
                    PAGO RECIBIDO
                </h2>
                        
                <div className="grid grid-cols-1 gap-3">
                        <div className="flex items-center gap-3">
                            <Tag size={18} className="text-indigo-500" />
                            <p className="text-gray-600"><strong>Materia:</strong> {servicio?.materia}</p>
                        </div>
                            <div className="flex items-center gap-3">
                                <Receipt size={18} className="text-indigo-500" />
                                <p className="text-gray-600"><strong>Precio Servicio:</strong> $ {formatearPrecio(servicio?.preciocobrado)}</p>
                            </div>
                            <div className="flex items-center gap-3">
                                <Calendar size={18} className="text-indigo-500" />
                                <p className="text-gray-600"><strong>Fecha de entrega:</strong> {formatearFechaAntesDe(servicio?.fechaentrega)} </p>
                            </div>
                            <div className="flex items-center gap-3">
                                <Calendar size={18} className="text-indigo-500" />
                                <p className="text-gray-600"><strong>Codigo:</strong> {servicio?.codigo} </p>
                            </div>
                </div>

                {/* TU ENTREGA YA ESTA LISTA */}
                {estaTotalmentePago ? (
                    <div className="bg-emerald-50 border-2 border-emerald-200 p-5 rounded-2xl animate-in fade-in slide-in-from-top-4 duration-700">
                        <div className="flex items-center gap-3 mb-2">
                            <CheckCircle className="text-emerald-600" size={24} />
                            <h3 className="font-black text-emerald-900 uppercase text-xs tracking-widest">
                                ¡Trabajo Liquidado!
                            </h3>
                        </div>
                        <p className="text-emerald-800 text-sm leading-relaxed font-medium">
                            El trabajo ya se encuentra **totalmente pago**. Por favor, haz clic en el botón de abajo <strong>"IR A VER EL SERVICIO"</strong> para descargar tus archivos.
                        </p>
                    </div>
                ) : (
                    <div className="bg-amber-50 border-l-4 border-amber-500 p-5 rounded-r-2xl">
                        <p className="text-[10px] text-amber-600 uppercase font-black tracking-widest mb-1">Aún tienes un saldo pendiente</p>
                        <p className="text-2xl font-black text-amber-700">
                            $ {formatearPrecio(saldoPendiente)}
                        </p>
                        <p className="text-xs text-amber-600/80 mt-2">
                            Completa el pago total para habilitar la entrega de tu trabajo.
                        </p>
                    </div>
                )}

            </div>
        );
    }

    const TransaccionExitosa = () => {
        return (
            <div className="p-8">
               
                {tipoEntidad === "SOLICITUD" ? <SolicitudAgendadaWidget /> : <ServicioAgendadoWidget />}
                
                <ResumenPagoWidget />
                                    
            </div> 
        );
    };

    const ResumenPagoWidget = () => {
        return (
            <div className="mx-4 md:mx-6 mb-6 bg-slate-50 rounded-2xl p-6 border border-slate-100">
                <p className="text-[10px] font-black text-slate-400 uppercase tracking-[0.2em] mb-4 text-center">Detalles de la Transacción</p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="border-b md:border-b-0 md:border-r border-slate-200 pb-2 md:pb-0 md:pr-4">
                        <p className="text-slate-400 text-[10px] font-bold uppercase">Referencia</p>
                        <p className="font-mono font-bold text-slate-800 break-all text-xs">{infoPago?.reference || '---'}</p>
                    </div>
                    <div className="md:pl-4">
                        <p className="text-slate-400 text-[10px] font-bold uppercase">Monto Total</p>
                        <p className="text-xl font-black text-slate-900">$ {(infoPago?.amount_in_cents / 100).toLocaleString()}</p>
                    </div>
                </div>
            </div>
        );
    };

    const TransaccionFallida = () =>{
       return(
         <div className="space-y-6 animate-in zoom-in-95 duration-500">
        <div className="bg-gray-50 rounded-2xl p-6 border border-gray-100">
            <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest mb-4">Información Técnica</p>
            <div className="space-y-3 text-sm">
                <div className="flex justify-between">
                    <span className="text-gray-500">Referencia:</span>
                    <span className="font-mono font-bold">{infoPago?.reference || '---'}</span>
                </div>
                <div className="flex justify-between">
                    <span className="text-gray-500">Estado:</span>
                    <span className={`font-bold ${esPendiente ? 'text-amber-600' : 'text-red-600'}`}>
                        {infoPago?.status || 'RECHAZADO'}
                    </span>
                </div>
                <div className="flex justify-between border-t pt-2">
                    <span className="text-gray-500">Monto:</span>
                    <span className="font-bold text-gray-800">$ {(infoPago?.amount_in_cents / 100).toLocaleString()}</span>
                </div>
            </div>
        </div>

        <div className="text-center p-4">
            <p className="text-gray-500 text-sm italic">
                {esPendiente 
                    ? "Por favor no intentes pagar de nuevo hasta que el estado cambie." 
                    : "Si el problema persiste, contacta a tu banco o intenta con otro medio."}
            </p>
        </div>
        </div>
       );
    }

    const HeaderDinamico = () => {
        return (
            <div className={`p-8 text-center transition-all duration-500 ${
                esExitoso ? 'bg-emerald-50' : esPendiente ? 'bg-amber-50' : 'bg-red-50'
            }`}>
                {/* --- ICONO CENTRAL --- */}
                <div className="flex justify-center mb-4">
                    {esExitoso ? (
                        <div className="bg-emerald-500 p-3 rounded-full shadow-lg shadow-emerald-200 animate-in zoom-in duration-300">
                            <CheckCircle className="w-12 h-12 text-white" />
                        </div>
                    ) : esPendiente ? (
                        <div className="bg-amber-500 p-3 rounded-full shadow-lg shadow-amber-200 animate-in zoom-in duration-300">
                            <Clock className="w-12 h-12 text-white" />
                        </div>
                    ) : (
                        <div className="bg-red-500 p-3 rounded-full shadow-lg shadow-red-200 animate-in zoom-in duration-300">
                            <span className="text-white text-4xl font-black px-4">!</span>
                        </div>
                    )}
                </div>

                {/* --- TÍTULO --- */}
                <h1 className={`text-2xl font-black uppercase tracking-tight ${
                    esExitoso ? 'text-emerald-900' : esPendiente ? 'text-amber-900' : 'text-red-900'
                }`}>
                    {esExitoso ? '¡Pago Recibido!' : esPendiente ? 'Pago Pendiente' : 'Pago Rechazado'}
                </h1>

                {/* --- MENSAJE DESCRIPTIVO --- */}
                <p className={`text-sm mt-2 px-6 font-medium leading-relaxed ${
                    esExitoso ? 'text-emerald-700' : esPendiente ? 'text-amber-700' : 'text-red-700'
                }`}>
                    {esExitoso 
                        ? "Tu transacción ha sido confirmada exitosamente." 
                        : obtenerMensajeEstado()}
                </p>
            </div>
        );
    };

    const FooterDinamico = () => {
        // CASO 1: PAGO EXITOSO
        if (esExitoso) {
            return (
                <div className="p-8 pt-0">
                    {!usuario ? (
                        <div className="bg-indigo-50 rounded-2xl p-5 border border-indigo-100">
                            <p className="text-indigo-900 text-sm text-center font-medium mb-3">
                                ¿Deseas revisar los detalles?
                            </p>
                            <div className="grid grid-cols-2 gap-3">
                                <button 
                                    onClick={() => navigate('/registroCliente')}
                                    className="flex items-center justify-center gap-2 py-3 bg-white border-2 border-indigo-600 text-indigo-600 rounded-xl font-bold hover:bg-indigo-50 transition-colors text-sm"
                                >
                                    <UserPlus size={18} />
                                    CREAR CUENTA
                                </button>
                                <button 
                                    onClick={() => navigate('/login')}
                                    className="flex items-center justify-center gap-2 py-3 bg-indigo-600 text-white rounded-xl font-bold hover:bg-indigo-700 transition-colors text-sm"
                                >
                                    <LogIn size={18} />
                                    INGRESAR
                                </button>
                            </div>
                        </div>
                    ) : (
                        <button 
                            disabled={!servicio?.codigo}
                            onClick={() => navigate(`/contabilidad/detalles_servicio/DUFY%20ASESORIAS/${servicio?.codigo}`)}
                            className={`w-full py-4 rounded-2xl font-bold transition-all flex items-center justify-center gap-2 ${
                                servicio?.codigo 
                                ? "bg-indigo-600 text-white hover:bg-indigo-700 shadow-lg shadow-indigo-100" 
                                : "bg-gray-200 text-gray-500 cursor-not-allowed"
                            }`}
                        >
                            {servicio?.codigo ? "IR A VER EL SERVICIO" : "ASIGNANDO CÓDIGO..."}
                        </button>
                    )}
                </div>
            );
        }

        // CASO 2: PAGO RECHAZADO O PENDIENTE
        return (
            <div className="p-8 pt-0 space-y-3">
                <button 
                    onClick={() => BotonAtras(navigate, location, `/pago/${solicitud.nombreEmpresa}/${solicitud.idcotizacion}/${solicitud.cliente}`)}
                    className="w-full py-4 bg-red-600 text-white rounded-2xl font-bold hover:bg-red-700 transition-all shadow-lg shadow-red-100 flex items-center justify-center gap-2"
                >
                    {esPendiente ? "REVISAR ESTADO" : "INTENTAR NUEVAMENTE"}
                </button>
                <button 
                    onClick={() => navigate(-1)}
                    className="w-full py-3 bg-gray-100 text-gray-500 rounded-2xl font-bold hover:bg-gray-200 transition-all text-sm"
                >
                    VOLVER AL INICIO
                </button>
            </div>
        );
    };

    return (
        <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
            <div className="max-w-xl w-full bg-white rounded-3xl shadow-2xl overflow-hidden border border-gray-100">
                
                <HeaderDinamico />

                {/* --- 2. CUERPO DINÁMICO --- */}
                {esExitoso ? <TransaccionExitosa /> : <TransaccionFallida />}

                {/* FOOTER */}
                <FooterDinamico />

            </div>
        </div>
    );

};

export default PagoResultado;